'use strict';

(function () {
  'use strict';

  var app = angular.module('translations', ['pascalprecht.translate', 'tmh.dynamicLocale', 'msCore']);
  app.config(['$translateProvider', 'tmhDynamicLocaleProvider', function ($translateProvider, tmhDynamicLocaleProvider) {
    $translateProvider.useUrlLoader('/apiproxy/public/translations');
    $translateProvider.useSanitizeValueStrategy(null);
    tmhDynamicLocaleProvider.localeLocationPattern('https://cdnjs.cloudflare.com/ajax/libs/angular-i18n/1.6.0/angular-locale_{{locale}}.min.js');
  }]);
})();